/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const Footer = styled.footer({
  alignItems: 'center',
  background: token('color.background.input'),
  borderTop: `1px solid ${token('color.border')}`,
  display: 'flex',
  justifyContent: 'flex-end',
  minHeight: `${gridSize() * 5}px`,
});
